import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Displays applcation logo
 */
@Component({
  selector: 'ly-logo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent {}
